<template>
  <div>
    <header-ton></header-ton>
    <div class="">
      <img class="brand-img" src="../../../public/images/bg/7.png" height="460" alt />
    </div>
    <booter-ton></booter-ton>
  </div>
</template>
  
  <script>
import HeaderTon from "@/components/HeaderTon";
import BooterTon from "@/components/BooterTon";
export default {
  components: {
    HeaderTon,
    BooterTon,
  },
  data() {
    return {
      keywords: "",
    };
  },
  mounted() {},
  methods: {},
};
</script>
  
  <style>
page {
  background: #f7f7f7;
}
</style>